import {
    EDIT_COLLECTIONS_GENERALES,
    EDIT_COLLECTIONS_HIGH_FREQUENCY,
    EDIT_COLLECTIONS_METADATA_MAPPER,
    EDIT_COLLECTIONS_RESET,
    EDIT_COLLECTIONS_IA_CONFIG
} from "../redux-const";

const initialState = {
    loading: false,
    tab: 0,
    new: true,
    useSchema: false,
    name: "",
    schema: "",
    skipUnchangedDocuments: false,
    reindexing: false,
    useSchema: false,
    rejectInvalid: false,
    schemaType: "JSON",
    schema: "",
    rules: [],
    metadataMapper: {
        enabled: false,
        mapperMode: "merge",
        documentExample: "",
        expression: ""
    },
    indexes: [],
    webhooks: [],
    highFrequency: {
        inheritsFromProject: true,
        enabled: false,
        maxUpdates: 100,
        timeWindow: 1000,
        timeWindowUnit: "SECONDS",
        cooldown: 1000,
        cooldownUnit: "SECONDS",
    },
    iaConfig: {
        description: "",
        importantStatements: "",
        ignoreStatements: ""
    }
}


export const reducer = (state = initialState, action) => {
    const payload = action.payload;

    switch (action.type) {
        case EDIT_COLLECTIONS_GENERALES:
            return {
                ...state,
                ...payload
            }
        case EDIT_COLLECTIONS_RESET:
            return initialState
        case EDIT_COLLECTIONS_METADATA_MAPPER:
            return {
                ...state,
                metadataMapper: {
                    ...payload
                }
            }
        case EDIT_COLLECTIONS_HIGH_FREQUENCY:
            return {
                ...state,
                highFrequency: {
                    ...payload
                }
            }
        case EDIT_COLLECTIONS_IA_CONFIG:
            return {
                ...state,
                iaConfig: {
                    ...payload
                }
            }
        default:
            return state
    }
};

export default reducer;
